import React, { useState, useEffect } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';




function PanelContentTbl(props) {
    const { lstContent, lstContentId, handleSelect, layoutTypeId, setLstContentOrdered } = props;

    const [panelContentId, setPanelContentId] = useState(0);
    const [lstContentFiltered, setLstContentFiltered] = useState([]);

    const mediaTypes = new Map([
        [10, "image"],
        [20, "video"],
        [30, "audio"]
    ]);
    const orientations = new Map([
        [10, "landscape"],
        [20, "portrait"],
        [30, "square"]
    ]);
    const colgrp = <colgroup>
        <col width="10"></col>
        <col width="80"></col>
        <col width="35"></col>
        <col width="35"></col>
        <col width="30"></col>
        <col width="20"></col>
    </colgroup>

    useEffect(() => {
        const inEligible = layoutTypeId === 20 ? 10 : 20;
        const filteredList = lstContent.filter(content => content.layoutTypeId !== inEligible);
        setLstContentFiltered(filteredList);
        setLstContentOrdered(filteredList);
        // setLstContentFiltered(lstContent);
    }, [lstContent, layoutTypeId]);
    
    
    
    const handleDragEnd = async (result) => {
        if (!result.destination) return;
        
        const items = Array.from(lstContentFiltered);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        // console.log("item after moving rows", items);
        await setLstContentOrdered(items);
        await setLstContentFiltered(items);
    };

    const renderTableBody = () => {
        return lstContentFiltered && lstContentFiltered.length ? lstContentFiltered.map((content, index) => (
            <Draggable key={content.contentId} draggableId={String(content.contentId)} index={index}>
                {(provided) => (
                    <tr
                        key={content.contentId}
                        id={content.contentId}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                    >
                        <td className="text-left"><span style={{ margin: 0, width: "100%" }} className="glyphicon glyphicon-th-list" ></span></td>
                        <td className="text-left">{content.content}</td>
                        <td className="text-center">{mediaTypes.get(content.mediaTypeId)}</td>
                        <td className="text-center">{orientations.get(content.layoutTypeId)}</td>
                        <td className="text-center">{content.displayTm}</td>
                        <td className="text-center">
                            <input type="checkbox"
                                className="form-check-input"
                                checked={!!lstContentId && lstContentId.includes(content.contentId)}
                                onChange={() => handleSelect(content.contentId)}
                                onClick={(e) => { e.stopPropagation(); }}
                            /></td>
                    </tr>
                )}
            </Draggable>
        )
        ) : null
    };



    return (

        <div >
            <div className="col-md-12 col-xs-12 col-centered padding-remove " >
                <table className="tableLayout1" >
                    {colgrp}
                    <thead>
                        <tr>
                            <th ></th>
                            <th >
                                Content
                            </th>
                            <th >
                                Type
                            </th>
                            <th >
                                Layout
                            </th>
                            <th >
                                Timing
                            </th>
                            <th >
                                Select
                            </th>
                        </tr>
                    </thead>
                </table>
                <div className="tableDiv" style={{ height: `calc(90vh - 130px)` }}>
                    <table className="tableLayout">
                        {colgrp}
                        <DragDropContext onDragEnd={handleDragEnd}>
                            <Droppable droppableId="droppable-1" type="PERSON">
                                {(provided) => (
                                    <tbody
                                        id="panelContentTableBody"
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                    >
                                        {renderTableBody()}
                                        {provided.placeholder}
                                    </tbody>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default PanelContentTbl;